import { Component, Input, input, OnInit } from '@angular/core';
import { OrderReceiptState } from 'src/app/models/order-receipt/orderReceiptState';
import { OrderReceiptOrder } from 'src/app/models/order-receipt/orderReceiptOrder';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'order-receipt',
    standalone: true,
    templateUrl: './order-receipt.html',
    styleUrls: ['./order-receipt.scss'],
    imports: [
        CommonModule,
    ]
})
export class OrderReceiptComponent implements OnInit {

  @Input() public orderReceipt: any = {} as OrderReceiptState;

  public transactionFeeEnabled: boolean = (window as any)['process_env'].IS_ENABLED_TRANSACTION_FEE;
  public taxServiceEnabled: boolean = (window as any)['process_env'].IS_ENABLED_SALESTAX;
  public isShippingAvailable: boolean = (window as any)['process_env'].SHIPPING;

  public isShippingValid: boolean = true;
  public isTaxValid: boolean = true;

  public orderShippingCost: number = 0;
  public upsellsTotal: number = 0;
  public upsellsTotalTax: number = 0;
  public upsellsShippingCost: number = 0;
  public totalTransactionsFees: number = 0;

  public order: OrderReceiptOrder = {} as OrderReceiptOrder;

  constructor() { }

  ngOnInit() {
    this.init();
  }

  private init() {
    if (!this.orderReceipt) return;

    this.order = this.orderReceipt.orderDetails
      ? this.orderReceipt.orderDetails.order
        ? this.orderReceipt.orderDetails.order
        : this.orderReceipt.orderDetails
      : {} as OrderReceiptOrder;

    this.orderShippingCost = this.order.orderShippingCost;

    if (this.taxServiceEnabled && this.orderReceipt.taxData) {
      this.isTaxValid = this.orderReceipt.taxData.isValid;
    }

    if (this.isShippingAvailable && this.orderReceipt.shippingInfo) {
      this.isShippingValid = this.orderReceipt.shippingInfo.isValid;
    }

    this.totalTransactionsFees = this.order.orderTransactionFee
      ? this.order.orderTransactionFee : 0;

    const upsells: Array<OrderReceiptOrder> = this.orderReceipt.upsells;
    if (upsells && upsells.length > 0) {
      for (const upsell of upsells) {
        this.upsellsTotal += upsell.total;
        // Check if tax Service Enabled and Upsell order have a tax then we calculate tax amount for upsells
        if (this.taxServiceEnabled && upsell.tax) {
          this.upsellsTotalTax += upsell.tax;
        }
        this.upsellsShippingCost += upsell.orderShippingCost;
        this.totalTransactionsFees += upsell.orderTransactionFee ? upsell.orderTransactionFee : 0;
        this.totalTransactionsFees = +this.totalTransactionsFees.toFixed(2);
      }
    }
    console.log(this.order)
  }

}

